export const trails_en = {
    "green-circle": "Novice",
    "blue-square": "Easy",
    "black-diamond": "Advanced",
    "double-black-diamond": "Expert",
    "triple-black-diamond": "Expert",
    "green": "Novice",
    "blue": "Easy",
    "red": "Intermediate",
    "black": "Advanced",
    "freeride": "Freeride",
    "other": "Other"
}

export const trails_de = {
    "green-circle": "Anfänger",
    "blue-square": "Einfach",
    "black-diamond": "Fortgeschrittene",
    "double-black-diamond": "Expert",
    "triple-black-diamond": "Expert",
    "green": "Anfänger",
    "blue": "Einfach",
    "red": "Mittelschwer",
    "black": "Fortgeschrittene",
    "freeride": "Freeride",
    "other": "Other"
}

export const trails_fr = {
    "green-circle": "Débutant",
    "blue-square": "Facile",
    "black-diamond": "Avancée",
    "double-black-diamond": "Expert",
    "triple-black-diamond": "Expert",
    "green": "Débutant",
    "blue": "Facile",
    "red": "Moyenne",
    "black": "Avancée",
    "freeride": "Freeride",
    "other": "Other"
}

export const trails_it = {
    "green-circle": "Principiante",
    "blue-square": "Facile",
    "black-diamond": "Difficile",
    "double-black-diamond": "Expert",
    "triple-black-diamond": "Expert",
    "green": "Principiante",
    "blue": "Facile",
    "red": "Moderada",
    "black": "Difficile",
    "freeride": "Freeride",
    "other": "Other"
}

export const trails_es = {
    "green-circle": "Fácil",
    "blue-square": "Fácil",
    "black-diamond": "Avanzado",
    "double-black-diamond": "Expert",
    "triple-black-diamond": "Expert",
    "green": "Fácil",
    "blue": "Fácil",
    "red": "Moderada",
    "black": "Avanzado",
    "freeride": "Freeride",
    "other": "Other"
}

export const trails_nb = {
    "green-circle": "Meget lett",
    "blue-square": "Lett",
    "black-diamond": "Krevende",
    "double-black-diamond": "Ekspert",
    "triple-black-diamond": "Ekspert",
    "green": "Meget lett",
    "blue": "Lett",
    "red": "Middels",
    "black": "Krevende",
    "freeride": "Freeride",
    "other": "Other"
}